import { LOCALE } from "./localeConstants.js";
import FALLBACK_COPY from "../../../assets/data/locale/fallback.json";

// setting initial locale to en-en so that copySelector throws correct errors even
// if no locale is set before the first loadLocaleCopy action is dispatched
export const INITIAL = {
  isError: false,
  isReady: false,
  isFetching: false,
  locale: "en-en",
  locales: {
    fallback: FALLBACK_COPY
  }
};

export function localeReducer(state = INITIAL, action = {}) {
  switch (action.type) {
    case LOCALE.SET:
      return {
        ...state,
        locale: action.locale
      };

    case LOCALE.LOAD:
      return state;

    case LOCALE.REQUEST:
      return {
        ...state,
        isError: false,
        isFetching: true,
        isReady: false
      };

    case LOCALE.RECEIVE:
      return {
        ...state,
        isFetching: false,
        isReady: true,
        locales: {
          ...state.locales,
          [action.locale]: action.data
        }
      };

    // setting isReady to true so that we can proceed with fallback copy
    // this will be handled by the copySelector
    case LOCALE.FAILURE:
      return {
        ...state,
        isError: true,
        isFetching: false,
        isReady: false
      };

    default:
      return state;
  }
}
